import { apiSlice } from "@/shared/api/api-slice"
import type { UploadDocumentRequest, UploadDocumentResponse } from "@/shared/types/api/business-mode.types"

interface UpdateBusinessDocumentRequest {
  id: number
  data: UploadDocumentRequest
}

export const updateBusinessDocumentApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessDocumentsList"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      updateBusinessDocument: builder.mutation<UploadDocumentResponse, UpdateBusinessDocumentRequest>({
        query: ({ id, data }) => ({
          url: `/api/v1/business/documents/${id}`,
          method: "PATCH",
          body: data
        }),
        invalidatesTags: () => [{ type: "BusinessDocumentsList" as const }]
      })
    })
  })

export const { useUpdateBusinessDocumentMutation } = updateBusinessDocumentApi
